import React, { Component } from 'react'
import TeacherPV from './TeacherPV'
import AuthA from '../../store/actions/AuthA'
import {connect} from 'react-redux'

import axios from 'axios'

class TeacherPC extends Component {
  constructor(props) {
    super(props);
    this.state = {
      teacher: {}
    };
    this.getTeacher = this.getTeacher.bind(this);
    this.goBack = this.goBack.bind(this);
  }

  getTeacher() {
    const id = this.props.match.params.id;

    axios.get(process.env.REACT_APP_URL+'/teachers/'+id, {
      params: {
        access_token: localStorage.getItem('token')
      }
    })
    .then(response => {
      this.setState({ teacher: response.data });
    });
  }

  goBack() {
    this.props.history.goBack();
  }

  componentDidMount() {
    this.props.authFn.getToken()
    this.props.onContentMount({title:'School Setup / Teachers / Teacher Profile'});
    this.getTeacher();
  }

  render() {
    return (
      <TeacherPV
        auth={this.props.auth}
        userType={this.props.userType}
        teacher={this.state.teacher}
        goBack={this.goBack}
      />
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    authFn: AuthA(dispatch)
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.AuthR.auth,
    userType: state.AuthR.userType
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(TeacherPC);
